import { useState, useEffect } from "react";
import { X } from "lucide-react";

// Positioning lives in FloatingActionButtons, which stacks this with
// BuyerPortalButton — this component only renders the button itself.
const WhatsAppButton = () => {
  const [isHovered, setIsHovered] = useState(false);
  const [showTooltip, setShowTooltip] = useState(false);

  const phoneNumber = "447379339449";
  const message = "Hello, I'm interested in your solar panels. Can you help me?";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  // Auto-show the "Need help?" nudge, but only on screens wide enough
  // that its box doesn't land on top of page content (on narrow mobile
  // viewports it was covering the Contact page's Email card) — the
  // button itself is always reachable either way.
  useEffect(() => {
    if (typeof window === "undefined" || !window.matchMedia("(min-width: 768px)").matches) {
      return;
    }
    setShowTooltip(true);
    const timer = setTimeout(() => setShowTooltip(false), 5000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative flex items-center">
      {/* "Need help?" nudge — anchored to the left of the button (not stacked
          above it) so it can never grow into BuyerPortalButton's space */}
      {showTooltip && (
        <div className="absolute right-full mr-3 bottom-0 animate-fade-in">
          <div className="relative bg-navy text-white px-4 py-2 rounded-lg shadow-lg text-sm max-w-[200px]">
            <button
              onClick={() => setShowTooltip(false)}
              className="absolute -top-2 -right-2 bg-slate-700 rounded-full p-0.5 hover:bg-slate-600"
            >
              <X size={12} />
            </button>
            <p className="font-medium">Need help?</p>
            <p className="text-slate-300 text-xs mt-1">Chat with us on WhatsApp</p>
          </div>
          <div className="absolute top-1/2 -right-1.5 -translate-y-1/2 rotate-45 w-3 h-3 bg-navy"></div>
        </div>
      )}

      {/* WhatsApp Button */}
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="whatsapp-button"
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        className="group relative flex items-center"
      >
        {/* Hover label (suppressed while the auto nudge is showing, so the two never overlap each other) */}
        <span
          className={`absolute right-full mr-3 bg-navy text-gold px-4 py-2 rounded-lg text-sm font-medium whitespace-nowrap shadow-lg transition-all duration-300 ${
            isHovered && !showTooltip ? "opacity-100 translate-x-0" : "opacity-0 translate-x-2 pointer-events-none"
          }`}
        >
          Chat on WhatsApp
        </span>

        {/* Button */}
        <div
          className="relative w-14 h-14 rounded-full flex items-center justify-center shadow-xl transition-all duration-300 hover:scale-110"
          style={{
            background: "linear-gradient(135deg, #0B1629 0%, #1a2d4a 100%)",
            border: "2px solid #C5A059"
          }}
        >
          {/* Pulse animation ring */}
          <div
            className="absolute inset-0 rounded-full animate-ping opacity-30"
            style={{ backgroundColor: "#C5A059" }}
          ></div>

          {/* WhatsApp Icon */}
          <svg
            viewBox="0 0 24 24"
            className="w-7 h-7 relative z-10"
            style={{ fill: "#C5A059" }}
          >
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/>
          </svg>
        </div>
      </a>
    </div>
  );
};

export default WhatsAppButton;
